import React from 'react';
import Paginations from '../../common/paginations';
import moment from 'moment';
import constant from '../../../constant';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const Index = ({ data, limit, handlePageChange }) => {
    const { page, total, projects, groups } = data;

    const renderTableHeader = () => (
        <thead>
            <tr>
                <th className="w500">Project</th>
                <th>Unscheduled</th>
                <th className="w150">Scheduled</th>
                <th className="w150">In Progress</th>
                {/* <th className="w150">Passed</th> */}
                <th className="w150">Accepted</th>
                <th className="w150">Total Inspection</th>
            </tr>
        </thead>
    );

    const renderRow = (item) => (
        <tr key={item.PROJECT_ID} >
            <td>
                <p className="s1">
                    <Link to={{
                        pathname: constant.Authedcomponent.inspectionProject.url,
                        state: {
                            projectId: item.PROJECT_ID,
                            projectName: item.PROJECT_NAME
                        }
                    }}>{item.PROJECT_CODE} - {item.PROJECT_NAME}</Link>
                </p>
            </td>
            <td>
                <p className="s1">{item.UNSCHEDULED}</p>
            </td>
            <td>
                <p className="s1">{item.SCHEDULED}</p>
            </td>
            <td>
                <p className="s1">{item.IN_PROGRESS}</p>
            </td>
            {/* <td>
                <p className="s1">{item.PASSED}</p>
            </td> */}
            <td>
                <p className="s1">{item.ACCEPTED}</p>
            </td>
            <td>
                <p className="s1">{item.TOTAL_INSPECTION}</p>
            </td>
        </tr>
    );

    return (
        <React.Fragment>
            <table className="plan-approval-table">
                {renderTableHeader()}
                <tbody>
                    {groups
                        ? Object.entries(groups).map(([groupName, groupProjects]) => (
                            <React.Fragment key={groupName}>
                                <div className="company-name-hul">
                                    <h4>{groupName}</h4>
                                </div>
                                {groupProjects.map(renderRow)}
                            </React.Fragment>
                        ))
                        : projects?.length > 0
                            ? projects.map(renderRow)
                            : (
                                <tr>
                                    <td colSpan="7" className="text-center">No Record Found</td>
                                </tr>
                            )}
                </tbody>
            </table>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={handlePageChange}
            />
        </React.Fragment>
    );
};

export default Index;
